// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__21wXn","buttons":"Header_buttons__2pq8T","mobile":"Header_mobile__29DKN","desktop":"Header_desktop__IxNL8","close":"Header_close__3pGCF"};